import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, CreateUserDialogueHandler } from '../types';
import CreateUserContext from './CreateUserContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type CreateUserDialogueProps = {
  handleDialogue: DialogueHandler<CreateUserDialogueHandler>;
};

type FC = FunctionComponent<CreateUserDialogueProps>;

const CreateUserDialogue: FC = ({ handleDialogue }: CreateUserDialogueProps) => {
  const { showCreateUserSuccessAlert, showCreateUserErrorAlert, CreateUserError } = useContext(CreateUserContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.Create.Dialog' });

  return useMemo(
    () => (
      <div>
        {/* Create User Error */}
        <ConfirmationDialogue
          isVisible={showCreateUserErrorAlert}
          title={t('CreateUserError.title')}
          status="error"
          subTitle={`${CreateUserError}`}
          confirm={{
            label: t('CreateUserError.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />
        {/* Create User Success */}
        <ConfirmationDialogue
          isVisible={showCreateUserSuccessAlert}
          title={t('CreateUserSuccess.title')}
          status="success"
          subTitle={t('CreateUserSuccess.subTitle')}
          confirm={{
            label: t('CreateUserSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
      </div>
    ),
    [showCreateUserSuccessAlert, showCreateUserErrorAlert],
  );
};

export default CreateUserDialogue;
